import { render, staticRenderFns } from "./LoadingBoxForApp.vue?vue&type=template&id=ebb9f4d6&scoped=true&"
import script from "./LoadingBoxForApp.vue?vue&type=script&lang=js&"
export * from "./LoadingBoxForApp.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBoxForApp.vue?vue&type=style&index=0&id=ebb9f4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb9f4d6",
  null
  
)

export default component.exports